/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import faroLogger from "../utils/faro";
import { LogLevel } from "@grafana/faro-web-sdk";

export type LoggerParams = {
  error?: string | object;
  message?: string;
  action?: string;
  feature?: string;
  args?: object;
  level?: LogLevel;
};

export const useLogger = (module: string) => {
  return ({
    level = LogLevel.ERROR,
    action = "unknown",
    feature = "unknown",
    args = {},
    error,
    message = "",
  }: LoggerParams) => {
    const logObject = {
      module,
      action,
      feature,
      ...args,
    };

    switch (level) {
      case LogLevel.ERROR:
        const logError = typeof error === "string" ? new Error(error) : error;
        faroLogger.error(logError, logObject);
        break;
      case LogLevel.INFO:
        faroLogger.info(message, logObject);
        break;
      case LogLevel.WARN:
        faroLogger.warn(message, logObject);
        break;
      default:
        break;
    }
  };
};
